<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import InStateApplication from './InStateApplication';
import OutStateApplication from './OutStateApplication';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Approvals',
		meta: [
			{
				name: 'Approval',
			},
		],
	},
	components: { InStateApplication, OutStateApplication },
	props: ['id', 'user_id'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			currentUserData: JSON.parse(localStorage.getItem('user')),
			userId: '',
			approvalId: '',
			approvalForm: {
				user_id: null,
				user_type_id: null,
				user_status: null,
				review_application: null,
				confirm_application_status: null,
				review_character_references: null,
				character_reference_confirmed: null,
				start_sterling_background_check: null,
				confirm_sterling_background_status: null,
				remove_ss_and_dL: null,
				kickoff_dhs_background_check: null,
				start_dhs_background_check: null,
				confirm_dhs_status: null,
				upload_letter_r_drive: null,
				document_case_details: null,
				dhs_background_check_complete: null,
				schedule_orientation_date: null,
				send_calendar_invite: null,
				send_orientation_confirmation_email: null,
				send_orientation_kickoff_email: null,
				orienation_confirmed: null,
				application_approved: null,
				assign_applicant: null,
				send_approval_email_confirmation: null,
				follow_up_character_reference: null,
				received_character_reference: null,
				send_appilcation_received_email: null,
				send_dhs_orientation_email: null,
				state_id_authorization: null,
				send_fingerprinting_instructions_email: null,
				initiate_netstudy_for_fingerprinting: null,
				check_fingerprinting_status: null,
				confirm_fingerprinting_with_applicant: null,
				fingerprinting_completed: null,
				assigned_to_programs: null,
				send_assignment_email_to_mentor_ccm: null,
				email_applicant_background_info_to_ccm: null,
				send_meeting_invite_applicant: null,
				confirm_meeting_date: null,
				document_meeting_date: null,
				review_application_waitlist: null,
				screening_meeting_complete: null,
				introduce_applicant_to_client: null,
				confirm__roi_release_info_signature: null,
				document_introduction_date_client: null,
				send_assignment_email: null,
				feedback_on_assignment: null,
				schedule_first_assignment: null,
				confirm_onboarding_complete: null,
				confirm_assignment_date_role: null,
				due_dates: [],
				comments: [],
			},
			recordNotFound: false,
			isLoading: false,
		};
	},
	mounted() {
		this.userId = this.user_id;
		this.approvalId = this.id;
		this.getApproval();
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	methods: {
		getApproval() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.get('admin/user/approval/' + this.approvalId, config)
					.then((res) => {
						if (res.status == 200) {
							this.approvalForm = res.data.response;
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err.response.data.error.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		...authFackMethods,
	},
};
</script>

<template>
	<div v-if="approvalForm.user">
		<div v-if="approvalForm.user.location_id == 2 || (approvalForm.user.location_id == 4 && approvalForm.user.user_type_id == 4)">
			<InStateApplication :approvalId="id" :userId="user_id" />
		</div>
		<div v-else>
			<OutStateApplication :approvalId="id" :userId="user_id" />
		</div>
	</div>
</template>
